(function(){
  var header=document.querySelector('.site-header');
  function setH(){ if(header) document.documentElement.style.setProperty('--header-h', header.offsetHeight+'px'); }
  setH(); window.addEventListener('resize', setH);

  document.addEventListener('click', function(e){
    document.querySelectorAll('details[data-dd][open]').forEach(function(d){ if(!d.contains(e.target)) d.removeAttribute('open'); });
  });

  document.querySelectorAll('[data-thumb]').forEach(function(b){
    b.addEventListener('click', function(){
      var img=document.getElementById('PdpMainImg'); if(!img) return;
      img.removeAttribute('srcset'); img.src=b.getAttribute('data-src');
      document.querySelectorAll('[data-thumb]').forEach(function(x){ x.classList.toggle('is-active', x===b); });
    });
  });

  document.querySelectorAll('[data-qty]').forEach(function(w){
    var input=w.querySelector('input');
    w.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        var v=(parseInt(input.value,10)||1)+(b.getAttribute('data-step')==='+'?1:-1);
        input.value=Math.max(1,v);
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });
  });

  var root=document.querySelector('[data-product]');
  var pj=document.querySelector('[data-product-json]');
  if(root && pj){
    var product=JSON.parse(pj.textContent);
    var fmtStr=root.getAttribute('data-money-format')||'{{amount}}';
    var ppu=parseFloat(root.getAttribute('data-ppu')||'1');
    function fmt(cents){
      return fmtStr.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, key){
        var n=(cents/100).toFixed(key.indexOf('no_decimals')>-1?0:2);
        var parts=n.split('.'); var comma=key.indexOf('comma')>-1;
        parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma?'.':',');
        return parts.join(comma?',':'.');
      });
    }
    function selected(){ var s=[]; root.querySelectorAll('[data-option-index]:checked').forEach(function(r){ s[+r.getAttribute('data-option-index')]=r.value; }); return s; }
    function matches(v,s){ return v.options.every(function(o,i){ return s[i]===undefined || o===s[i]; }); }
    function update(){
      var s=selected();
      var v=product.variants.filter(function(x){ return matches(x,s); })[0];
      root.querySelectorAll('[data-option-index]').forEach(function(r){
        var t=s.slice(); t[+r.getAttribute('data-option-index')]=r.value;
        var ok=product.variants.some(function(x){ return x.available && matches(x,t); });
        r.parentNode.classList.toggle('is-unavailable', !ok);
      });
      root.querySelectorAll('[data-opt-label]').forEach(function(l){ l.textContent=s[+l.getAttribute('data-opt-label')]||''; });
      var btns=document.querySelectorAll('[data-atc]');
      if(!v){ btns.forEach(function(b){ b.disabled=true; var t=b.querySelector('[data-atc-text]'); if(t) t.textContent=root.getAttribute('data-unavailable'); }); return; }
      var qEl=root.querySelector('[data-qty] input'); var q=qEl?(parseInt(qEl.value,10)||1):1;
      document.querySelectorAll('[data-variant-id]').forEach(function(i){ i.value=v.id; });
      document.querySelectorAll('[data-price]').forEach(function(e){ e.textContent=fmt(v.price); });
      document.querySelectorAll('[data-total]').forEach(function(e){ e.textContent=fmt(v.price*q); });
      document.querySelectorAll('[data-compare]').forEach(function(e){ e.textContent=v.compare_at_price>v.price?fmt(v.compare_at_price):''; });
      document.querySelectorAll('[data-points]').forEach(function(e){ e.textContent=Math.floor(v.price*q/100*ppu); });
      document.querySelectorAll('[data-variant-title]').forEach(function(e){ e.textContent=v.title; });
      btns.forEach(function(b){ b.disabled=!v.available; var t=b.querySelector('[data-atc-text]'); if(t) t.textContent=v.available?root.getAttribute('data-add'):root.getAttribute('data-soldout'); });
      if(v.featured_media && v.featured_media.preview_image){
        var img=document.getElementById('PdpMainImg');
        if(img){ img.removeAttribute('srcset'); img.src=v.featured_media.preview_image.src; }
      }
      if(window.history && history.replaceState){ var u=new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({},'',u.toString()); }
    }
    root.addEventListener('change', update);
    update();
  }

  var mainAtc=document.querySelector('.pdp .btn-atc'), bar=document.querySelector('.sticky-atc');
  if(mainAtc && bar && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){ var e=en[0]; bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top<0); }).observe(mainAtc);
  }

  document.querySelectorAll('[data-recs-url]').forEach(function(s){
    fetch(s.getAttribute('data-recs-url')).then(function(r){ return r.text(); }).then(function(t){
      var d=document.createElement('div'); d.innerHTML=t;
      var n=d.querySelector('[data-recs-url]');
      if(n && n.innerHTML.trim().length) s.innerHTML=n.innerHTML;
    }).catch(function(){});
  });
})();